import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const LawsItemPage = lazy(() => import('./index'))

function DocsItemPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <LawsItemPage {...props} />
        </Suspense>
    );
}

export default DocsItemPageLazy;
export { DocsItemPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/docs-item-page/lazy.js